export const Data = [
  {
    id: 1,
    metric: 'Clarity',
    score: 0
  },
  {
    id: 2,
    metric: 'Confidence',
    score: 0
  },
  {
    id: 3,
    metric: 'Vocabulary',
    score: 0
  },
  {
    id: 4,
    metric: 'Poise',
    score: 0
  }
]
